module.exports = __webpack_public_path__ + "img/room-1.2192112d.jpg";